















import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";

export default {
    name: "CorbeilleListFilters",
    components: { TableSort, TableFilters },
    props: {
        // Options {id, name} fournies par l'API (metadata de la liste)
        types: Array,
        auteurs: Array,
    },
    data() {
        return {
            filters: {},
            columns: [
                {
                    id: "recherche",
                    name: "Élément ou raison",
                    type: TableColumn.ColumnType.text,
                },
                {
                    id: "type",
                    name: "Type",
                    type: TableColumn.ColumnType.option,
                    options: this.types,
                },
                {
                    id: "supprimePar",
                    name: "Supprimé par",
                    type: TableColumn.ColumnType.option,
                    options: this.auteurs,
                },
                {
                    id: "supprimeLe",
                    name: "Supprimé le",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "supprime_le",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.desc,
                },
            ],
        };
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", _.merge({}, this.filters));
            this.$emit("input", _.merge({}, this.filters));
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
    },
    watch: {
        // Les colonnes gardent leur identité (filtre en cours de saisie) :
        // seules leurs options suivent l'API.
        types(types): void {
            _.find(this.columns, { id: "type" }).options = types;
        },
        auteurs(auteurs): void {
            _.find(this.columns, { id: "supprimePar" }).options = auteurs;
        },
    },
};
